module.exports = __webpack_public_path__ + "static/img/hatopress-whitechapel-closeup.b6bc9b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workshops/hatopress-whitechapel-closeup.jpg
// module id = 55
// module chunks = 1